module.exports = __webpack_public_path__ + "static/media/pee-chee-logo.60f3c880.png";